
export function Title()
{
	return 'Artist Profiles';
}
